var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiCog01 = function SvgApiCog01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 48.66,
    y1: 164.65,
    x2: 155.39,
    y2: 30.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 48.66,
    y1: 164.65,
    x2: 155.39,
    y2: 30.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 50.89,
    y1: 166.42,
    x2: 157.62,
    y2: 32.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 39.06,
    y1: 157.03,
    x2: 145.79,
    y2: 22.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 65.94,
    y1: 178.37,
    x2: 172.67,
    y2: 43.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 31.16,
    y1: 150.75,
    x2: 137.89,
    y2: 16.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 29.34,
    y1: 149.31,
    x2: 136.07,
    y2: 14.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 61.45,
    y1: 174.81,
    x2: 168.18,
    y2: 40.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 63.36,
    y1: 176.33,
    x2: 170.09,
    y2: 41.93,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M192.63,121.17l-6.9-3.98c1.16-5.76,1.74-11.53,1.74-17.18s-.58-11.51-1.72-17.2l6.87-3.97c2.13-1.23,3.65-3.21,4.29-5.58.64-2.37.31-4.85-.92-6.98l-18.79-32.54c-1.23-2.13-3.21-3.65-5.58-4.29-2.37-.64-4.85-.31-6.98.92l-6.88,3.97c-8.68-7.64-18.91-13.55-29.79-17.23v-7.9c0-5.07-4.13-9.2-9.2-9.2h-37.57c-5.07,0-9.2,4.13-9.2,9.2v7.9c-10.82,3.66-21.03,9.59-29.75,17.26l-6.92-3.99c-2.13-1.23-4.61-1.55-6.98-.92-2.37.64-4.36,2.16-5.58,4.29L4,66.27c-1.23,2.13-1.55,4.61-.92,6.98.64,2.37,2.16,4.36,4.29,5.58l6.9,3.98c-1.16,5.76-1.74,11.53-1.74,17.18s.58,11.51,1.72,17.2l-6.87,3.97c-4.39,2.54-5.9,8.17-3.37,12.56l18.79,32.54c2.54,4.39,8.17,5.9,12.56,3.37l6.87-3.97c8.68,7.64,18.91,13.55,29.79,17.23v7.9c0,5.07,4.13,9.2,9.2,9.2h37.57c5.07,0,9.2-4.13,9.2-9.2v-7.9c10.82-3.66,21.03-9.59,29.75-17.26l6.92,3.99c4.39,2.54,10.03,1.03,12.56-3.37l18.79-32.54c2.54-4.39,1.03-10.03-3.37-12.56ZM190.91,130.79l-18.79,32.54c-.92,1.59-2.96,2.14-4.54,1.22l-8.76-5.06c-1.11-.64-2.52-.49-3.46.39-8.96,8.29-19.74,14.54-31.18,18.08-1.23.38-2.07,1.52-2.07,2.8v10.04c0,1.83-1.49,3.33-3.33,3.33h-37.57c-1.83,0-3.33-1.49-3.33-3.33v-10.04c0-1.29-.84-2.42-2.07-2.8-11.51-3.56-22.3-9.81-31.22-18.06-.56-.51-1.27-.78-1.99-.78-.5,0-1.01.13-1.47.39l-8.72,5.04c-1.59.92-3.63.37-4.54-1.22l-18.79-32.54c-.92-1.59-.37-3.63,1.22-4.54l8.72-5.03c1.11-.64,1.68-1.93,1.4-3.19-1.34-5.95-2.02-12.02-2.02-18.03s.69-11.97,2.05-18.01c.28-1.25-.28-2.55-1.4-3.19l-8.75-5.05c-.77-.44-1.32-1.16-1.55-2.02-.23-.86-.11-1.76.33-2.52l18.79-32.54c.44-.77,1.16-1.32,2.02-1.55.86-.23,1.76-.11,2.52.33l8.76,5.06c1.11.64,2.52.49,3.46-.39,8.96-8.29,19.74-14.54,31.18-18.08,1.23-.38,2.07-1.52,2.07-2.8v-10.04c0-1.83,1.49-3.33,3.33-3.33h37.57c1.83,0,3.33,1.49,3.33,3.33v10.04c0,1.29.84,2.42,2.07,2.8,11.5,3.56,22.3,9.81,31.22,18.06.94.87,2.35,1.03,3.46.39l8.72-5.04c.77-.44,1.67-.56,2.52-.33.86.23,1.58.78,2.02,1.55l18.79,32.54c.44.77.56,1.67.33,2.52s-.78,1.58-1.55,2.02l-8.72,5.03c-1.11.64-1.68,1.93-1.4,3.19,1.34,5.95,2.02,12.02,2.02,18.03s-.69,11.97-2.05,18.01c-.28,1.25.28,2.55,1.4,3.19l8.75,5.05c1.59.92,2.13,2.96,1.22,4.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,40.7c-32.7,0-59.3,26.6-59.3,59.3s26.6,59.3,59.3,59.3,59.3-26.6,59.3-59.3-26.6-59.3-59.3-59.3ZM100,153.42c-29.46,0-53.42-23.97-53.42-53.42s23.97-53.42,53.42-53.42,53.42,23.97,53.42,53.42-23.97,53.42-53.42,53.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.96,84.54h-10.96c-1.62,0-2.94,1.31-2.94,2.94v25.05c0,1.62,1.31,2.94,2.94,2.94s2.94-1.31,2.94-2.94v-6.46h8.02c5.93,0,10.76-4.83,10.76-10.76s-4.83-10.76-10.76-10.76ZM110.96,100.2h-8.02v-9.78h8.02c2.7,0,4.89,2.19,4.89,4.89s-2.19,4.89-4.89,4.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.96,86.45c-.43-1.15-1.52-1.9-2.75-1.9h-3.13c-1.22,0-2.32.76-2.75,1.9l-9.39,25.05c-.57,1.52.2,3.21,1.72,3.78s3.21-.2,3.78-1.72l1.63-4.36h13.15l1.63,4.36c.44,1.18,1.56,1.91,2.75,1.91.34,0,.69-.06,1.03-.19,1.52-.57,2.29-2.26,1.72-3.78l-9.39-25.05ZM75.27,103.33l4.37-11.67,4.37,11.67h-8.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.18,84.54c-1.62,0-2.94,1.31-2.94,2.94v25.05c0,1.62,1.31,2.94,2.94,2.94s2.94-1.31,2.94-2.94v-25.05c0-1.62-1.31-2.94-2.94-2.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121,34.17c2.04.65,4.07,1.4,6.04,2.24.37.16.76.24,1.15.24,1.14,0,2.23-.67,2.7-1.79.63-1.49-.06-3.22-1.55-3.85-2.14-.91-4.34-1.73-6.55-2.43-1.54-.49-3.2.36-3.69,1.91-.49,1.54.36,3.2,1.91,3.69Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.32,133.03c-.78-1.42-2.56-1.95-3.98-1.17-1.42.78-1.95,2.56-1.17,3.98,1.22,2.23,2.57,4.43,4.01,6.53.57.83,1.49,1.27,2.42,1.27.57,0,1.15-.17,1.66-.52,1.34-.92,1.68-2.75.76-4.08-1.33-1.93-2.57-3.96-3.69-6.02Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.99,168.82c-15.73-1.36-30.66-8.17-42.04-19.19-1.16-1.13-3.02-1.1-4.15.07-1.13,1.16-1.1,3.02.07,4.15,12.35,11.96,28.55,19.35,45.62,20.83.09,0,.17.01.26.01,1.51,0,2.79-1.15,2.92-2.68.14-1.61-1.06-3.04-2.67-3.18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.24,38.08c-1.34-.91-3.17-.57-4.08.77-.91,1.34-.57,3.17.77,4.08,13.64,9.32,23.5,23.19,27.78,39.05.35,1.31,1.54,2.17,2.83,2.17.25,0,.51-.03.77-.1,1.57-.42,2.49-2.03,2.07-3.6-4.64-17.21-15.34-32.26-30.13-42.37Z"
  })));
};
export default SvgApiCog01;